import moment from 'moment';
import React, { useMemo, useState } from 'react';
import IndeterminateCheckbox from 'components/@extended/IndeterminateCheckbox';
import ComptrollerDataTable from 'pages/comptroller/comptroller-table/ComptrollerDataTable';

import viewIcon from 'assets/images/table-icons/view_blue.svg';
import editIcon from 'assets/images/table-icons/edit_green.svg';

import { Button, Spin, Tooltip } from 'antd';
import { isEmpty } from 'lodash';
import FileViewIconButton from 'components/button/FileViewIconButton';
import EditIconButton from 'components/button/EditIconButton';

function ListViewControlSelfAssuranceV2({ data, isLoading, showModal, setItem }) {
	const [rowSelection, setRowSelection] = useState([]);

	const COLUMNS = useMemo(
		() => [
			{
				id: 'Selection',
				align: 'center',
				onClicked: true,
				cellAlign: 'center',
				Cell: ({ row, index }) => <IndeterminateCheckbox id={index} {...row.getToggleRowSelectedProps()} />,
				Header: ({ getToggleAllRowsSelectedProps, index }) => (
					<IndeterminateCheckbox id={index + '1'} sx={{ color: '#858585', padding: '0px' }} {...getToggleAllRowsSelectedProps()} />
				),
			},
			{
				Header: 'Control ID',
				// accessor: "dateString",
				accessor: 'controlId',
			},
			{
				Header: 'Date',
				// accessor: "effectiveDate",
				accessor: (data) => (data.answerDueDate ? moment(data.answerDueDate).format('YYYY-DD-MM') : ''),
			},
			{
				Header: 'Domain',
				// accessor: "dateString",
				accessor: 'controlDomain',
			},
			{
				Header: 'Sub Domain',
				// accessor: "shiftName",
				accessor: 'controlSubDomain',
			},
			{
				Header: 'Controls',
				accessor: 'controlQuestion',
			},
			// {
			//   Header: "Entry Time",
			//   // accessor: "annual-jobBand",
			//   accessor: (data) => (data.entryTime ? moment(data.entryTime).utc().format("hh:mm A") : ""),
			// },
			// {
			//   Header: "Earliest Exit Timeline",
			//   // accessor: "earliestExitTimeline",
			//   accessor: (data) => (data.earliestExitTimeline ? moment(data.earliestExitTimeline).utc().format("hh:mm A") : ""),
			// },
			{
				Header: 'Assurer',
				accessor: 'assurerName',
				// accessor: (data) => (data.exitTime ? moment(data.exitTime).utc().format("hh:mm A") : ""),
			},
			{
				Header: 'Owner',
				accessor: 'ownerName',
			},
			{
				Header: 'Frequently',
				accessor: 'frequency',
			},
			{
				Header: 'Actual',
				accessor: 'actual',
			},
			{
				align: 'center',
				Header: 'Action',
				disableSortBy: 'true',
				Cell: (cell) => (
					<div style={{ textAlign: 'center' }}>
						<Tooltip title="View">
							{/* <Button
								type="text"
								icon={<img src={viewIcon} width={16} height={16} alt="view" />}
								onClick={(e) => {
									e.stopPropagation();
									showModal();
									setItem(cell.row.original.id);
								}}
							></Button> */}

							<FileViewIconButton
								onClick={(e) => {
									showModal();
									setItem(cell.row.original.id);
								}}
							/>
						</Tooltip>

						<Tooltip title="Edit">
							{/* <Button
								type="text"
								icon={<img src={editIcon} width={16} height={16} alt="edit" />}
								onClick={(e) => {
									e.stopPropagation();
									//   navigate("/static/function/edit", { state: { functionMasterList, editList: cell.row.original, tab: searchParams.get("tab") } });
									// console.log("cell.row.original", cell.row.original);
								}}
							></Button> */}

							<EditIconButton
								onClick={(e) => {
									e.stopPropagation();
									//   navigate("/static/function/edit", { state: { functionMasterList, editList: cell.row.original, tab: searchParams.get("tab") } });
									// console.log("cell.row.original", cell.row.original);
								}}
							/>
						</Tooltip>
					</div>
				),
			},
		],
		[]
	);

	return (
		<Spin spinning={isLoading} style={{ maxHeight: '100%' }}>
			<ComptrollerDataTable
				onClickHandler={() => {}}
				DATA={isEmpty(data) ? [] : data}
				rowSelection={rowSelection}
				setRowSelection={setRowSelection}
				COLUMNS={COLUMNS}
				xlsxFileName="leave-management"
			/>
		</Spin>
	);
}

export default ListViewControlSelfAssuranceV2;
